import { render, staticRenderFns } from "./MainNavbar.vue?vue&type=template&id=031eddb0&scoped=true&"
import script from "./MainNavbar.vue?vue&type=script&lang=js&"
export * from "./MainNavbar.vue?vue&type=script&lang=js&"
import style0 from "./MainNavbar.vue?vue&type=style&index=0&id=031eddb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031eddb0",
  null
  
)

export default component.exports